import styled from "styled-components";

export const MessageContainer = styled.div`
	width: 100% !important;
	color: var(--feedback-error);
	font-size: var(--font-size-small);
	font-family: var(--font-family-metropolis);
	font-weight: 600;
	margin: 0.7rem 0;
`;
